import type { ReactNode } from 'react';
import { LAYOUT_MAX_WIDTH, type LayoutWidth } from './tokens';

interface AppBannerProps {
  message: ReactNode;
  action?: ReactNode;
  width?: LayoutWidth;
}

export function AppBanner({ message, action, width = 'default' }: AppBannerProps) {
  return (
    <div
      className="relative z-10 border-b border-blue-500/20 bg-blue-500/10"
      role="status"
    >
      <div
        className={`mx-auto flex items-center justify-between gap-3 px-4 py-2.5 sm:px-6 ${LAYOUT_MAX_WIDTH[width]}`}
      >
        <span className="text-xs text-blue-300/90 sm:text-sm">{message}</span>
        {action}
      </div>
    </div>
  );
}
